

import React from "react"; 
import { Loading, ActionBar, BoxArea } from "../component/BaseComponent";
import MenuComp, { PageTitle, IconList } from "../component/menucomp";
import { FormGroup } from '../component/form';

import Pagination from "../component/Paginator"
import { FaEdit } from "react-icons/fa";
import { HttpsRequest, GetAuth, Alerts } from '../component/Utils';
import { APIRoute, RespStatus } from "../component/texts";

 
 

type CustomerType = {
    body: Record<string, string|number>[];
    isbusy: boolean;
    pager: PagerType,
    new_customer: Record<string, any>[];
    edit_mode: boolean;
    form: Record<string, any>[];
    data: Record<string, number | string | unknown>;
    formaction:  1| 2| undefined;
}


export default class CustomerUI extends React.Component<IProps, CustomerType> {


    constructor(props: IProps){

        super(props); 

        this.state = {
            body: [],
            isbusy: false, 
            pager: {
                next_page: 0,
                page: 1,
                pages: [],
                prev_page: 0,
                total: 0,
                rows: 10
            },
            edit_mode: false, 
            new_customer: [],
            form: [],
            data: {},
            formaction: undefined
        }

    }

    render (){
 
          
        let sidecls = this.state.edit_mode ? "col-md-6 col-sm-12" : "col-md-8 col-sm-12";

        return (
            <div>
                <MenuComp />
                <br />
                <br />
                <ActionBar
                    classname={sidecls}
                    placeholder={"search"}
                    search={false}
                    btntitle={"Add Customer"}
                    btnfunc={(e) => { e.preventDefault(); this.initiate_new_form()}}
                    btnicon={IconList['people'] as JSX.Element}
                />

                <br/>
                <br/>

                <div className="container-fluid">
                    <div className="row posrel">

                        <BoxArea classname={sidecls + ' posrel'} >

                            <PageTitle title={'Customers'} />

                            <div className="table-responsive posrel">
                                <table className="table table-condensed table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <td> Date </td>
                                            <td> Name </td>
                                            <td> Phone </td>
                                            <td> Email </td>
                                            {/* <td> Address </td>*/}
                                            <td> Action </td>
                                        </tr>
                                    </thead>
                                    <tbody> 
                                        {
                                            this.state.body.length === 0 ? <tr> <td colSpan={5} className="center"> <i> no data found...</i></td> </tr> : (
                                                this.state.body.map((item, idx) => (
                                                    <tr>
                                                        <td> {item.date} </td>
                                                        <td> {item.name} </td>
                                                        <td> {item.phone } </td>
                                                        <td> {item.email} </td>
                                                        {/* <td> {item.address} </td> */}
                                                        <td>  
                                                            <button className="btn btn-light btn-sm" onClick={() => this.get_user_form(item.id as number)}> <FaEdit /> Edit </button>
                                                        </td>  
                                                    </tr>
                                                ))
                                            )
                                        }
                                    </tbody>
                                </table>

                                <Pagination {...this.state.pager} navigate={this.refresh_page} />
                            </div>
                            <div>
                                {this.state.isbusy && <Loading />}
                            </div>

                        </BoxArea>

                        {
                            this.state.edit_mode ? (
                                <BoxArea classname={'col-md-6'} >
                                    <PageTitle title={ this.state.formaction === 1? 'New Customer': 'Edit Customer'} />
                                    <br />
                                    <form method='post' autoComplete="off" onSubmit={this.publish_update}>
                                        {
                                            this.state.form.map((fld, idx) => {
                                                return <FormGroup
                                                    key={`device-${idx}`}
                                                    obj={fld} onchange={
                                                        (e: React.ChangeEvent<HTMLInputElement>) => {
                                                        this.onchange(e);
                                                    }}
                                                    onselectchange={this.onchange}
                                                    textarea_change={(e: React.ChangeEvent<HTMLTextAreaElement|HTMLInputElement>)=> this.onchange(e as any)}
                                                />;
                                            })
                                        }

                                        <div className="mb-4 mt-4">
                                            <div className="form-group row">
                                                <div className="row">
                                                    <div className="d-grid gap-2 col-md-6 col-sm-12 mb-3">
                                                        <button type="submit" className="btn btn-primary btn-lg">
                                                            Save Changes
                                                        </button>
                                                    </div>
                                                    <div className="d-grid gap-2 col-md-6 col-sm-12 mb-3">
                                                        <button type="button" onClick={() => this.setState({ edit_mode: false })} className="btn btn-light btn-lg">
                                                            &nbsp;&nbsp; Close &nbsp;&nbsp;
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                </BoxArea>


                            ) : null
                        }
                        
                    </div>

                </div>
            </div>

        )
       
    }

    componentDidMount(): void {
        this.load_customer_data() 
    }

    load_customer_data = (args?: Record<string, string>) => {

        HttpsRequest.get(
            APIRoute.customers, 
            this.get_callback,  GetAuth(), 
            (args || {}), (r:RespArgs) => this.setState({isbusy: false})
        )
    }

    get_callback = (resp: RespArgs) => {
        
        if (resp.status === RespStatus.success){
            this.setState({
                body: resp.body.data, 
                isbusy: false, 
                edit_mode: false,
                pager: resp.body.pager ,
                form: [], // reset form every upload
                new_customer: resp.body.new_customer_form 
            })  

        } else {
            this.setState({
                isbusy: false 
            })
            
            Alerts.show_error(resp.status_msg); 

        }
 
    }

    initiate_new_form = () => {

        const nform = [...this.state.new_customer]; 
        this.setState({form: nform, edit_mode: true, formaction: 1}); 
        
    }
    
    refresh_page = (page: number, rows: string|undefined) => {       
        this.load_customer_data({page: String(page), rows:rows || '10'}); 
    }

    onchange = (event: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => {
 
        const {data} = this.state ; 

        data[event.target.name] = event.target.value; 

        this.setState({
            data
        })

    }

    get_user_form = (customer_id:number) => {

        const get_callback = (resp: RespArgs) => {
            
            if (resp.status === RespStatus.success){
                this.setState({
                    data: resp.body.initial_data,
                    isbusy: false, 
                    edit_mode: true,                    
                    form: resp.body.form, // reset form every upload
                    formaction: 2
                })  
    
            } else {
                this.setState({
                    isbusy: false 
                })
                
                Alerts.show_error(resp.status_msg); 
    
            }
        }

        HttpsRequest.get(
            APIRoute.customers_edit + customer_id, 
            get_callback,  GetAuth(), 
            {}, 
            (r:RespArgs) => this.setState({isbusy: false})
        )

        this.setState({isbusy: true, form: [], data:{},  edit_mode: false})

    }

    publish_update = (event: React.FormEvent<HTMLFormElement>) => {

        event.preventDefault(); 
        
        let url: string = APIRoute.customers_add ;  
        
        if (this.state.formaction === 2){
            url = APIRoute.customers_edit + this.state.data['id']            
        }

        HttpsRequest.post(url, 
            this.state.data, this.publish_callback, 
            GetAuth(),             
            (resp:RespArgs)=>this.setState({isbusy: false})
        )


    }

    publish_callback = (r:RespArgs) => {


        if (r.status == RespStatus.success){
 
            this.load_customer_data({page:'1'})

        } else {

            this.setState({form: r.body.form}); 
            Alerts.show_error(r.body.status_msg); 

        }

    }


}